import * as apiTo from '@/modular-api'

const initialState = () => ({
  mainDefinition: [],
  secDefinition: [],
  financialPeriods: null
})

export default {
  namespaced: true,
  state: initialState(),

  getters: {
    allLayouts: (state, getters, rootState) => rootState.widgets.layout,

    layout(state, getters) {
      return getters.allLayouts.find(l => l.name === 'financial-insights')
    },

    mainIndex(state, getters) {
      return getters.layout.sub_contexts.findIndex(el => el.name === 'main')
    },

    mainContext(state, getters) {
      return getters.layout.sub_contexts[getters.mainIndex]
    },

    mainAvailableElements(state, getters) {
      const index = getters.mainIndex
      return getters.layout.sub_contexts[index].available_elements
    },

    mainInitialDefinition(state, getters) {
      const index = getters.mainIndex
      return getters.layout.sub_contexts[index].definition
    },

    secIndex(state, getters) {
      return getters.layout.sub_contexts.findIndex(el => el.name === 'secondary')
    },

    secContext(state, getters) {
      return getters.layout.sub_contexts[getters.secIndex]
    },

    secAvailableElements(state, getters) {
      const index = getters.secIndex
      return getters.layout.sub_contexts[index].available_elements
    },

    secInitialDefinition(state, getters) {
      const index = getters.secIndex
      return getters.layout.sub_contexts[index].definition
    }
  },

  mutations: {
    setMainDefinition: (state, payload) => (state.mainDefinition = payload),
    setSecDefinition: (state, payload) => (state.secDefinition = payload),
    setFinancialPeriods: (state, payload) => (state.financialPeriods = payload),
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetFinancialPeriods({ commit }) {
      apiTo.GET_FINANCIAL_PERIODS().then(({ data }) => commit('setFinancialPeriods', data.result))
    }
  }
}
